import { combineReducers } from 'redux';
import list from 'providers/reducers/providers_list_reducers';
import form from 'providers/reducers/providers_form_reducers';

export const providersReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/reducers/index.js